import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";

const STORAGE_KEY = "voryzix_cookie_consent";

const updateConsent = (analytics) => {
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: analytics ? "granted" : "denied",
    });
  }
};

const CookieBanner = () => {
  const { t, locale } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, at: new Date().toISOString() })
      );
    } catch (e) {}
    updateConsent(choice === "accept");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 bg-[#0B192C] border-t-2 border-[#C85A32]"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
        <div className="flex flex-col lg:flex-row lg:items-center gap-4">
          <div className="flex-1 text-sm text-[#CBD5E1]">
            <div className="text-xs font-mono uppercase tracking-widest text-[#C85A32] mb-1">
              {t("cookie_banner.title")}
            </div>
            <p className="leading-relaxed">
              {t("cookie_banner.body")}{" "}
              <Link
                to={`/${locale}/cookies`}
                className="underline hover:text-white"
                data-testid="cookie-banner-learn-more"
              >
                {t("cookie_banner.learn_more")}
              </Link>
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 shrink-0">
            <button
              onClick={() => decide("essential")}
              className="px-4 py-2 text-xs font-mono uppercase tracking-wider border border-[#1E293B] text-[#CBD5E1] hover:text-white"
              data-testid="cookie-customize-button"
            >
              {t("cookie_banner.customize")}
            </button>
            <button
              onClick={() => decide("reject")}
              className="px-4 py-2 text-xs font-mono uppercase tracking-wider border border-[#1E293B] text-[#CBD5E1] hover:text-white"
              data-testid="cookie-reject-button"
            >
              {t("cookie_banner.reject")}
            </button>
            <button
              onClick={() => decide("accept")}
              className="px-4 py-2 text-xs font-mono uppercase tracking-wider bg-[#C85A32] text-white hover:bg-[#B24E2A]"
              data-testid="cookie-accept-button"
            >
              {t("cookie_banner.accept")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
